export default "__VITE_ASSET__ea926619__"